import { Component, OnInit } from '@angular/core';
import { MessageService } from 'src/app/services/message.service';
import { UserListModel } from 'src/app/services/users/models/user-list-model';
import { UsersService } from 'src/app/services/users/user.service';
import { SubmenuService } from '../../submenu/submenu.service';

@Component({
  selector: 'app-list',
  templateUrl: './list.component.html',
  styleUrls: ['./list.component.less']
})
export class ListComponent implements OnInit {

  page:number = 1;
  pageSize:number = 25;
  queryString= "";
  listData: UserListModel | undefined;
  
  constructor(public usersService: UsersService, public messageService:MessageService, public submenuService:SubmenuService) 
  { 
    
  }

  ngOnInit(): void {
    
    this.loadData();
  }

  loadData(){
    this.messageService.showLoading();
    this.usersService.loadPage(this.page, this.pageSize, this.queryString).subscribe((data:UserListModel) => {
        this.listData = data;
        this.messageService.hideLoading();
    },
    
    err => {
      this.messageService.hideLoading();
      this.messageService.showMessage(err.message, "error");
      console.log(err);
    });
  }

  ngAfterViewChecked(){
    this.submenuService.showRecordList("/users");    
  }
  
  stringify(obj:any){
    return JSON.stringify(obj);
  }

  changeUserStatus(user:any){
    this.usersService.changeUserStatus(user).subscribe(i=>{
      if(user.Deactivated){
        user.Deactivated = false;
      }else{
        user.Deactivated = true;
      }
    });
  }
}
